import React from 'react';

export default function Footer() {
    return (
        <>
            <footer class="main-footer">
                   <div> <a class="about-us-footer" href='about.html' target='_blank'>About Us</a></div>
                   <div class="copyright"> © 2019 Random Monster Generator</div>
            </footer>
        </>
    );
}

